<template>
  <v-sheet class="text-start">
    <page-head title="Teams" :breadcrumb="['Shop', 'Teams']">
      <template v-slot>
        <v-btn variant="outlined" color="primary" :to="{ name: 'teamInvite' }"
          ><v-icon>mdi-account-plus-outline</v-icon>Invite Team</v-btn
        >
      </template>
    </page-head>
    <v-data-table-server
      :items="dataTable.items"
      :items-per-page="dataTable.itemsPerPage"
      :items-length="dataTable.totalItems"
      :headers="dataTable.headers"
      :loading="dataTable.isLoading"
      :items-per-page-options="dataTable.itemsPerPageOptions"
      @update:options="updateTeam"
    >
      <template v-slot:[`item.email`]="{ value, item }">
        <a :href="`/management/team/id-${item.email}`">{{ value }}</a></template
      ></v-data-table-server
    >
  </v-sheet>
</template>

<script setup>
import PageHead from "@/components/admin_theme/PageHead.vue";
import { reactive, inject } from "vue";
import { authAxios } from "@/util/Axios";
import { DEFAULT_DATATABLE } from "@/util/List";

const cookies = inject("$cookies");
const shopId = cookies.get("toa-rim-shop");

const axios = authAxios();
const dataTable = reactive({
  headers: [
    { title: "User", key: "email", align: "start", sortable: false },
    { title: "Role", key: "role", align: "start", sortable: false },
    { title: "Activated", key: "activated", align: "start", sortable: false },
  ],
  ...DEFAULT_DATATABLE,
});

function updateTeam({ page, itemsPerPage }) {
  dataTable.isLoading = true;
  loadTeam(page, itemsPerPage).then((response) => {
    dataTable.isLoading = false;
    var result = [];
    response.data.data.forEach((user) => {
      result.push({ ...user, role: user.shop_role[shopId] });
    });
    dataTable.items = [...result];
    dataTable.totalItems = response.data.total_items;
  });
}

function loadTeam(page, length) {
  return axios({
    method: "GET",
    url: `${process.env.VUE_APP_BACKEND_URL}/api/shop/${shopId}/user/vuetify`,
    params: { page: page, length: length, search: "" },
  });
}
</script>
